import React from 'react';
import { Chip } from '@mui/material';
import { STATUS } from '@/constants/status';
import { RoadmapItem } from '@/models/RoadmapItem';
import './StatusChip.css';

interface StatusChipProps {
    data: RoadmapItem;
    chipSize?: 'small' | 'medium';
}

const StatusChip: React.FC<StatusChipProps> = ({ data, chipSize = 'small' }) => {
    if (!data || !data.statusOnUI) {
        return null;
    }

    const isReleased = data.statusOnUI === STATUS.RELEASED;
    const isNewRelease = data.statusOnUI === STATUS.NEW_RELEASE;

    const getChipClass = (): string => {
        if (isReleased) return 'status-chip status-chip-released';
        if (isNewRelease) return 'status-chip status-chip-new-release';
        if (data.statusOnUI === STATUS.IN_PROGRESS) return 'status-chip status-chip-in-progress';
        if (data.statusOnUI === STATUS.PLANNED) return 'status-chip status-chip-planned';
        if (data.statusOnUI === STATUS.UNDER_CONSIDERATION) return 'status-chip status-chip-under-consideration';
        return 'status-chip';
    };

    return (
        <Chip
            label={data.statusOnUI}
            variant={isReleased ? 'outlined' : 'filled'}
            size={chipSize}
            className={getChipClass()}
        />
    );
};

export default StatusChip;
